<template>
  <div class="PhoneheadTop" style="width: 100%">
    <nav
      class="navbar navbar-expand-md navbar-dark fixed-top head-bk"
      style="width: 100%; padding: 0 0px 0 0px"
    >
      <button
        class="navbar-toggler collapsed"
        type="button"
        data-toggle="collapse"
        data-target="#navbarsExampleDefault"
        aria-controls="navbarsExampleDefault"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        class="grid-content"
        style="text-align: right; margin: 0 5px; line-height: 46px"
      >
        <a class="register" @click="loginIn(1)" v-if="!user">登录</a>
        <span v-if="!user">&nbsp;|&nbsp;</span>
        <a class="register" @click="loginIn(2)" v-if="!user">注册</a>
        <el-dropdown
          v-else
          style="height: 35px; width: 125px"
          @command="logout"
        >
          <el-row class="linez">
            <el-col :span="4" style="position: relative; right: 15px">
              <img
                src="../assets/banner/header.png"
                style="vertical-align: middle"
              />
            </el-col>
            <el-col
              :span="16"
              style="
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                color: #909399;
                text-align: left;
              "
            >
              <a class="register">{{
                user.nickName == null || user.nickName == ""
                  ? user.userName
                  : user.nickName
              }}</a>
            </el-col>
            <el-col :span="4">
              <img
                src="../assets/banner/triangular.png"
                style="vertical-align: middle"
              />
            </el-col>
          </el-row>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div
        class="navbar-collapse collapse"
        id="navbarsExampleDefault"
        :key="otto"
      >
        <ul class="navbar-nav mr-auto">
          <li
            class="nav-item active"
            v-show="$store.state.pwoerMenuIds.channelIds.indexOf(item.id) != -1"
            v-for="item in channelList"
            :key="item.id"
            style="text-align: center"
          >
            <a
              class="nav-link"
              href="javascript:void(0)"
              @click="toUrl(item.url)"
              >{{ item.name }}</a
            >
          </li>
        </ul>
      </div>
    </nav>
    <login></login>
    <competition></competition>
  </div>
</template>

<script>
import login from "@/components/login";
import competition from "@/components/competition";
import { getFrontMenuMap, visitorQuery } from "../api/register";

export default {
  name: "HeadTop",
  data() {
    return {
      otto: this.$route.path,
      channelList: [],
      user: this.$store.state.user,
      isActive: "0",
    };
  },
  components: { login, competition },
  created() {
    this.handleMenuList();
    this.getMenu(this.siteId);
  },
  watch: {
    "$store.state.user": function (newFlag, oldFlag) {
      this.user = this.$store.state.user;
    },
  },
  computed: {
    defaultActive: function (e) {
      return this.$route.path;
    },
  },
  methods: {
    getMenu(siteId) {
      if (this.$store.state.user) {
        getFrontMenuMap(this.authURL).then((res) => {
          if (res.frontMenuMap.channelIds.length === 0) {
            this.getVisitorQuery();
          } else {
            this.$store.commit("setPwoerMenuIds", res.frontMenuMap);
          }
        });
      } else {
        this.getVisitorQuery(siteId);
      }
    },
    getVisitorQuery(siteId) {
      let url = this.siteURL + "/actuator/channel/list/" + siteId;
      visitorQuery(url).then((res) => {
        this.$store.commit("setPwoerMenuIds", res.data);
      });
    },
    handleMenuList() {
      console.log(this.siteURL);
      var api =
        this.siteURL + "/actuator/channel/list?parentId=-1&siteId="+this.siteId+"&showNav=0";
      this.axios.get(api, {}).then((response) => {
        this.channelList = response.data.rows;
      });
    },
    handleSelect(index, indexPath) {
      this.channelUrl = index;
    },
    signUp() {
      if (!this.user) {
        this.loginIn(1);
        return;
      }

      let userId = this.$store.state.user.userId;
      // 拼接请求url
      var api =
        this.baseURL + `/actuator/participant/list?userId=${userId}&siteId=`+this.siteId;
      this.axios.get(api, {}).then((res) => {
        if (res.data.rows.length == 1 && res.data.rows[0].id) {
          if (this.isActive === "0") {
            this.$router.push({
              path: "/myHome",
            });
          } else {
            this.$router.push({
              path: "/enMyHome",
            });
          }
        } else {
          if (this.isActive === "0") {
            this.$router.replace("/signUp");
          } else {
            this.$router.replace("/enSignUp");
          }
        }
      });
    },
    loginIn(index) {
      if (index === 1) {
        if (this.isActive === "0") {
          this.$store.commit("loginVisibleMutations", true);
        } else {
          this.$store.commit("enLoginVisibleMutations", true);
          this.$store.commit("loginVisibleMutations", false);
        }
      } else if (index === 2) {
        if (this.isActive === "0") {
          this.$store.commit("registerFormVisibleMutations", true);
        } else {
          this.$store.commit("enRegisterFormVisibleMutations", true);
        }
      }
    },
    logout() {
      this.user = undefined;
      this.$store.commit("logout");
    },
    previousReview() {
      let routeData = "";
      if (this.isActive === "0") {
        routeData = this.$router.resolve({ path: "/previousReviewHome" });
      } else {
        routeData = this.$router.resolve({ path: "/enPreviousReviewHome" });
      }
      window.open(routeData.href, "_blank");
    },
    toUrl(val) {
      if (val == "/") {
        this.$router.push("/Phone");
        this.otto = "/Phone";
      } else {
        this.$router.push(val);
        this.otto = val;
      }
    },
  },
};
</script>

<style >
.navigation .el-menu-item {
  font-size: 17px;
}
.navigation .el-menu.el-menu--horizontal {
  border-bottom: solid 0px #e6e6e6;
}
.login {
  margin-top: 10px;
  font-size: 14px;
  line-height: 22px;
  color: #1ab2ff;
  cursor: pointer;
  text-align: left;
  text-indent: 8px;
  width: 160px;
}
.login:hover {
  color: #2c2fd6;
}
</style>
<style >
.reg {
  width: 100%;
}
.reg .el-tabs__nav {
  width: 100%;
  float: none;
}
.reg .el-tabs__active-bar {
  background-color: #e4e7ed;
  height: 0px;
}
.reg .el-radio-group {
  float: left;
  position: relative;
  top: 12px;
}
.reg .el-tabs__item {
  padding: 0;
  background: #f9f9f9;
  width: 50%;
}
.reg .el-tabs__item.is-active {
  color: white;
  background: #1890ff;
}
.reg .el-tabs__nav-wrap::after {
  background-color: white;
}
.PhoneheadTop .el-dialog .el-dialog__body {
  padding: 30px 60px !important;
}
/* .el-dialog__headerbtn.el-dialog__headerbtn .el-dialog__close {
  display: none;
} */
.reg .el-form-item__content .el-button--primary {
  width: 100%;
}
.login-code .el-button {
  width: 110px;
}
/*  */
.el-radio-button--small .el-radio-button__inner {
  padding: 5px 5px !important;
}
.register {
  cursor: pointer;
}
.el-tag {
  height: 25px;
  line-height: 25px;
}
.PhoneheadTop .activeyu {
  background-color: #1890ff;
  border-color: #1890ff;
  color: white;
}
.el-tag {
  background-color: #e9e9e9;
  border-color: #e9e9e9;
  color: #afafaf;
  border-radius: 0px;
  margin: 14px -2px;
}
.PhoneheadTop .navbar-brand {
  font-size: 0.25rem;
}
.PhoneheadTop .head-bk {
  background: white;
}
.PhoneheadTop .navbar-dark .navbar-nav .active > .nav-link {
  color: #1890ff;
  font-size: 14px;
  border-bottom: 1px solid #f5f5f5;
}
.PhoneheadTop .mr-auto {
  background: #f8f8f8;
}
.PhoneheadTop .navbar-dark .navbar-toggler {
  border-color: #dddddd;
}
.PhoneheadTop .navbar-toggler {
  margin: 8px 5px;
}
.PhoneheadTop .el-tabs--card > .el-tabs__header {
  border-bottom: 0px solid #e4e7ed;
}
.PhoneheadTop .el-tabs__nav-wrap.is-scrollable {
  padding: 0;
}
.PhoneheadTop .navbar-dark .navbar-nav .nav-link {
  color: #007bff;
}
.linez {
  line-height: 28px;
  margin: 12px;
}

.navbar-dark .navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(144, 147, 153, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E") !important;
}
</style>



// WEBPACK FOOTER //
// src/views/PhoneHeadTop.vue